import React from 'react';
import { Link } from 'react-router-dom';
import css from './SectionMembershipMaybe.module.css';

/**
 * Promotional card surfaced on the listing page when the host has opted in
 * to the Ottawa–Rideau Lakes Membership program (regular and/or last-minute).
 *
 * Renders nothing if the listing isn't opted into either tier. If the
 * current viewer is already an active member, swaps copy to a "you're in"
 * affirmation instead of a sell.
 */
const SectionMembershipMaybe = props => {
  const { publicData, currentUser } = props;

  const acceptsRegular = publicData?.membership?.acceptsMember === true;
  const acceptsLastMinute = publicData?.lastMinuteMembership?.acceptsMember === true;
  if (!acceptsRegular && !acceptsLastMinute) return null;

  const viewerRegular = currentUser?.attributes?.profile?.publicData?.membership;
  const viewerLastMinute = currentUser?.attributes?.profile?.publicData?.lastMinuteMembership;
  const isActiveMember =
    viewerRegular?.status === 'active' || viewerLastMinute?.status === 'active';

  const headlines = [];
  if (acceptsRegular) headlines.push('$1 per booking for members');
  if (acceptsLastMinute) headlines.push('Last-minute deals within 48h');

  return (
    <section className={css.root} aria-labelledby="membership-card-title">
      <div className={css.eyebrow}>
        <span className={css.dot} aria-hidden="true" />
        <span className={css.eyebrowText}>
          <span className={css.eyebrowPrimary}>NEW</span>
          <span className={css.eyebrowSep}>·</span>
          <span>Ottawa–Rideau Lakes</span>
          <span className={css.eyebrowSep}>·</span>
          <span className={css.eyebrowMuted}>5 memberships only</span>
        </span>
      </div>

      {isActiveMember ? (
        <>
          <h3 id="membership-card-title" className={css.title}>
            You're a member — book this boat for $1.
          </h3>
          <p className={css.copy}>
            Pick your dates and the rental line drops to $1 at checkout. You only
            pay insurance, delivery, any add-ons you choose, and the damage deposit.
          </p>
          <Link to="/account/membership" className={css.ctaSecondary}>
            View my membership →
          </Link>
        </>
      ) : (
        <>
          <h3 id="membership-card-title" className={css.title}>
            Rent this boat for $1 all summer.
          </h3>
          <p className={css.copy}>
            Join the Ottawa–Rideau Lakes Membership and book participating Seadoos
            and boats for free. {headlines.join(' · ')}.
          </p>

          <div className={css.tiers}>
            {acceptsRegular ? (
              <div className={css.tier}>
                <div className={css.tierHead}>
                  <div className={css.tierPrice}>
                    $3,999 <span className={css.tierTax}>+ HST</span>
                  </div>
                  <div className={css.tierName}>Summer · 12 days</div>
                </div>
                <div className={css.tierInstallment}>4 × $1,000/mo</div>
                <div className={css.tierMeta}>2–6 day trips</div>
              </div>
            ) : null}
            {acceptsLastMinute ? (
              <div className={css.tier}>
                <div className={css.tierHead}>
                  <div className={css.tierPrice}>
                    $1,549 <span className={css.tierTax}>+ HST</span>
                  </div>
                  <div className={css.tierName}>Last-Minute · 8 days</div>
                </div>
                <div className={css.tierInstallment}>4 × $387/mo</div>
                <div className={css.tierMeta}>1–2 day trips · within 48h</div>
              </div>
            ) : null}
          </div>

          <div className={css.actions}>
            <Link to="/membership/join" className={css.cta}>
              Claim a spot →
            </Link>
            <span className={css.actionsHint}>
              3 or 4 monthly payments · $249.99 sign-up fee WAIVED for the first 5
            </span>
          </div>
        </>
      )}
    </section>
  );
};

export default SectionMembershipMaybe;
